import { FileText, Orbit, Sparkles, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

const ICONS = [FileText, Orbit, Sparkles, MessageCircle];

export function HowItWorks() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].how;

  return (
    <section id="how" className="scroll-mt-20 bg-ivory py-20 sm:py-28" data-testid="how-it-works">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow={t.eyebrow} title={t.title} />

        <div className="relative mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {/* connecting line on desktop */}
          <div className="pointer-events-none absolute left-0 right-0 top-9 hidden h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent lg:block" />
          {t.steps.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={step.title} delay={i * 100} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div className="relative flex h-16 w-16 items-center justify-center rounded-full border border-navy/10 bg-white shadow-sm">
                    <span className="absolute -right-1 -top-1 flex h-7 w-7 items-center justify-center rounded-full bg-gold font-heading text-sm font-bold text-navy">
                      {i + 1}
                    </span>
                    <Icon className="h-7 w-7 text-navy" strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-5 font-heading text-lg font-semibold text-navy">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-navy/65">{step.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
